export const platformAccess = {
  junior: {
    required: [
      { platform: 'JIRA', access: 'Product Owner', purpose: 'Backlog management and sprint planning', setup: 'Request product owner role in agile projects' },
      { platform: 'Confluence', access: 'Editor', purpose: 'Requirements documentation and knowledge sharing', setup: 'Request editor access to product spaces' },
      { platform: 'Slack', access: 'Member', purpose: 'Team communication and stakeholder updates', setup: 'Join #product-owners, #development-team, #stakeholders' },
      { platform: 'Miro', access: 'Editor', purpose: 'User story mapping and collaboration', setup: 'Request editor access to product boards' }
    ],
    optional: [
      { platform: 'Figma', access: 'Viewer', purpose: 'Design review and feedback', setup: 'Request viewer access to design files' },
      { platform: 'Google Analytics', access: 'Viewer', purpose: 'Basic product usage insights', setup: 'Request viewer access to product analytics' }
    ]
  },
  mid: {
    required: [
      { platform: 'ProductBoard', access: 'Admin', purpose: 'Product roadmap and feature prioritization', setup: 'Request admin access to product management workspace' },
      { platform: 'Aha!', access: 'Editor', purpose: 'Strategic roadmap planning', setup: 'Request editor permissions for roadmap planning' },
      { platform: 'Amplitude', access: 'Editor', purpose: 'Product analytics and user behavior analysis', setup: 'Request editor access for analytics dashboards' },
      { platform: 'Azure DevOps', access: 'Stakeholder', purpose: 'Enterprise agile planning', setup: 'Request stakeholder access to development projects' }
    ],
    optional: [
      { platform: 'Tableau', access: 'Creator', purpose: 'Advanced data visualization', setup: 'Request creator license for dashboard creation' },
      { platform: 'Power BI', access: 'Pro', purpose: 'Business intelligence and reporting', setup: 'Request Power BI Pro license' }
    ]
  },
  senior: {
    required: [
      { platform: 'Strategic Planning Platform', access: 'Admin', purpose: 'Enterprise product strategy planning', setup: 'Request admin access to strategic planning tools' },
      { platform: 'Advanced Analytics Suite', access: 'Admin', purpose: 'Executive reporting and business intelligence', setup: 'Request admin access to BI platforms' },
      { platform: 'Innovation Management Platform', access: 'Admin', purpose: 'Innovation pipeline and experimentation', setup: 'Request admin access to innovation tools' },
      { platform: 'Executive Dashboard', access: 'Admin', purpose: 'Executive reporting and KPI tracking', setup: 'Request dashboard creation and management permissions' }
    ],
    optional: [
      { platform: 'Market Intelligence Tools', access: 'Admin', purpose: 'Competitive analysis and market research', setup: 'Request admin access to market research platforms' },
      { platform: 'Customer Research Platform', access: 'Admin', purpose: 'User research and customer insights', setup: 'Request admin access to research tools' }
    ]
  }
};
